/** 运营管理系统 路由 **/

import Layout from "@/views/layout/Layout";

const propertyManRouter = {
  path: "/propertyMan",
  component: Layout,
  name: "propertyMan",
  meta: {
    title: "运营管理",
    icon: "property",
    roles: ["yunyingguanli"]
  },
  alwaysShow: true,
  children: [
    {
      path: "supportMan",
      component: () => import("@/views/propertyMan/supportMan/index"),
      name: "支援管理",
      meta: {
        title: "支援管理",
        roles: ["zhiyuanguanli"]
      },
      children: []
    },
    {
      path: "supportSheetQuery",
      component: () => import("@/views/propertyMan/supportMan/supportSheetQuery"),
      name: "支援单查询",
      meta: {
        title: "支援单查询",
        roles: ["zhiyuandanchaxun_web"]
      },
      children: []
    },
    {
      path: "purchaseAcceptance",
      component: () => import("@/views/propertyMan/supportMan/purchaseAcceptance"),
      name: "代购验收",
      meta: {
        title: "代购验收",
        roles: ["daigouyanshou_web"]
      },
      children: []
    },
    {
      path: "enterpriseAudit",
      component: () => import("@/views/propertyMan/enterpriseAudit"),
      name: "企业审核",
      meta: {
        title: "企业审核",
        roles: ["qiyeshenhe"]
      }
    },
    {
      path: "projectMaintenance",
      component: () => import("@/views/propertyMan/projectMaintenance"),
      name: "项目维护",
      meta: {
        title: "项目维护",
        roles: ["xiangmuweihu"]
      }
    },
    {
      path: "wasteMaintenance",
      component: () => import("@/views/propertyMan/wasteMaintenance"),
      name: "医废暂存点维护",
      meta: {
        title: "医废暂存点维护",
        roles: ["yifeizancundianweihu"]
      }
    },
    {
      path: "deptMaintenance",
      component: () => import("@/views/propertyMan/deptMaintenance"),
      name: "项目部门维护",
      meta: {
        title: "项目部门维护",
        roles: ["xiangmubumenweihu"]
      }
    },
    {
      path: "whiteList",
      component: () => import("@/views/propertyMan/whiteList/index"),
      name: "简E通白名单",
      meta: {
        title: "简E通白名单",
        roles: ["jianyitongbaimingdan"]
      }
    },
    {
      path: "menuMan",
      component: () => import("@/views/propertyMan/menuMan"),
      name: "简E通菜单管理",
      meta: {
        title: "简E通菜单管理",
        roles: ["jianyitongcaidanguanli"]
      }
    },
    {
      path: "whiteListLogout",
      component: () => import("@/views/propertyMan/whiteListLogout"),
      name: "小程序登录下线",
      meta: {
        title: "小程序登录下线",
        roles: ["xcxdengluxiaxian"]
      }
    },
    {
      path: "moduleMan",
      name: "模块管理",
      component: () => import("@/views/propertyMan/moduleMan"),
      meta: {
        title: "模块管理",
        roles: ["mokuaiguanli"]
      }
    },
    {
      path: "roleMan",
      name: "角色权限",
      component: () => import("@/views/propertyMan/roleMan"),
      meta: {
        title: "角色权限",
        roles: ["jianyitongjuesequanxian"]
      }
    },
    {
      path: "permissionMan",
      name: "管理权限",
      component: () => import("@/views/propertyMan/permissionMan"),
      meta: {
        title: "管理权限",
        roles: ["guanliquanxian"]
      }
    },
    {
      path: "districtMan",
      component: () => import("@/views/propertyMan/districtMan"),
      name: "区域管理",
      meta: {
        title: "区域管理",
        roles: ["quyuguanli"]
      },
      children: []
    }
  ]
};

export default propertyManRouter;
